import { context } from '@wikia/ad-engine';

export function getRoundelContext(): object {
	return {
		enabled: false,
		slots: {
			top_leaderboard: {
				sizes: context.get('experiments.oversizedAds')?.desktop?.top_leaderboard ?? [
					[728, 90],
					[970, 250],
				],
				siteId: '824040',
			},
			top_boxad: {
				sizes: context.get('experiments.oversizedAds')?.desktop?.top_boxad ?? [
					[300, 250],
					[300, 600],
				],
				siteId: '820933',
			},
			incontent_boxad: {
				sizes: context.get('experiments.oversizedAds')?.desktop?.incontent_boxad ?? [
					[160, 600],
					[300, 600],
					[300, 250],
					[300, 1050],
				],
				siteId: '820933',
			},
			bottom_leaderboard: {
				sizes: context.get('experiments.oversizedAds')?.desktop?.bottom_leaderboard ?? [
					[728, 90],
					[970, 250],
				],
				siteId: '824040',
			},
			incontent_player: {
				siteId: '820935',
			},
		},
	};
}
